import { fetchUserRoot, TYPE_SPACES, TYPE_SPACE_VIEWS, TYPE_USER } from '../user/fetch-user-root';

export const fetchSpaces = async (keepBrowserSpaceViewId?: boolean) => {
  await fetchUserRoot(TYPE_USER | TYPE_SPACES | TYPE_SPACE_VIEWS, keepBrowserSpaceViewId);
};
